module.exports = __webpack_public_path__ + "static/media/finsite_full.926d006d.png";